const selectStaticColors: object = {
  "blue-gray": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-blue-gray-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  gray: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-gray-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  brown: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-brown-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  "deep-orange": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-deep-orange-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  orange: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-orange-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  amber: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-amber-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  yellow: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-yellow-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  lime: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-lime-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  "light-green": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-light-green-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  green: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-green-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  teal: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-teal-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  cyan: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-cyan-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  "light-blue": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-light-blue-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  blue: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-blue-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  indigo: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-indigo-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  "deep-purple": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-deep-purple-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  purple: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-purple-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  pink: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-pink-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
  red: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-red-500",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
    },
  },
};

export default selectStaticColors;
